var _defs, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLongBuildingMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#59b2e3;opacity:1;}.cls-1,.cls-12,.cls-2,.cls-7,.cls-8,.cls-9{isolation:isolate;}.cls-12,.cls-2{fill:#ebfaff;}.cls-2{opacity:0.25;}.cls-3{fill:#01a09b;}.cls-4,.cls-5{fill:none;stroke:#535461;stroke-miterlimit:10;}.cls-5{stroke-width:2px;}.cls-6{fill:#017572;}.cls-10,.cls-7{fill:#93d502;}.cls-7,.cls-8,.cls-9{opacity:0.25;}.cls-11,.cls-9{fill:#5ec5c1;}.cls-12{opacity:0.25;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1015.05,696.25V651.63H988.23v44.62H956.47v-69H933.18V575.66h-19v-53H874.6v53H855.55v51.58H833v-62h-12.7V533.83H812.5V565.2H767.33v198H732.75V742.25H711.58v20.91H677V696.25H614.89V651.63H588.07v44.62h-1.41V782H558.43V731.79H524.55V782H496.32V627.24H474.45V575.66H394v51.58H372.82V899.78h674V696.25Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 386.14,
    y: 645.72,
    width: 29.45,
    height: 16.83
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 453.08,
    y: 645.72,
    width: 29.45,
    height: 16.83
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 386.14,
    y: 679.14,
    width: 29.45,
    height: 16.83
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 453.08,
    y: 679.14,
    width: 29.45,
    height: 16.83
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 386.14,
    y: 712.57,
    width: 29.45,
    height: 16.83
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 453.08,
    y: 712.57,
    width: 29.45,
    height: 16.83
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 386.14,
    y: 746,
    width: 29.45,
    height: 16.83
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 453.08,
    y: 746,
    width: 29.45,
    height: 16.83
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 386.14,
    y: 779.42,
    width: 29.45,
    height: 16.83
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 453.08,
    y: 779.42,
    width: 29.45,
    height: 16.83
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 386.14,
    y: 812.85,
    width: 29.45,
    height: 16.83
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 453.08,
    y: 812.85,
    width: 29.45,
    height: 16.83
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 386.14,
    y: 846.05,
    width: 29.45,
    height: 16.83
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 453.08,
    y: 846.05,
    width: 29.45,
    height: 16.83
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 507.46,
    y: 804.24,
    width: 68.72,
    height: 8.41
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 507.46,
    y: 817.04,
    width: 68.72,
    height: 8.41
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 507.46,
    y: 829.47,
    width: 68.72,
    height: 8.41
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 688.09,
    y: 808.51,
    width: 68.72,
    height: 8.41
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 688.09,
    y: 821.31,
    width: 68.72,
    height: 8.41
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 688.09,
    y: 833.76,
    width: 68.72,
    height: 8.41
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 507.46,
    y: 842.34,
    width: 68.72,
    height: 8.41
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 507.46,
    y: 855.22,
    width: 68.72,
    height: 8.41
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 507.46,
    y: 868.1,
    width: 68.72,
    height: 8.41
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 601.88,
    y: 716.17,
    width: 18.93,
    height: 24.54
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 643.49,
    y: 716.17,
    width: 18.93,
    height: 24.54
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 601.88,
    y: 756.01,
    width: 18.93,
    height: 24.54
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 643.49,
    y: 756.01,
    width: 18.93,
    height: 24.54
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 601.88,
    y: 795.84,
    width: 18.93,
    height: 24.54
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 643.49,
    y: 795.84,
    width: 18.93,
    height: 24.54
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 601.88,
    y: 835.43,
    width: 18.93,
    height: 24.54
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 643.49,
    y: 835.43,
    width: 18.93,
    height: 24.54
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 767.65,
    y: 581.2,
    width: 25.24,
    height: 32.26
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 767.65,
    y: 629.41,
    width: 25.24,
    height: 32.26
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 767.65,
    y: 676.37,
    width: 25.24,
    height: 32.26
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 767.65,
    y: 723.33,
    width: 25.24,
    height: 32.26
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 767.65,
    y: 770.29,
    width: 25.24,
    height: 32.26
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 767.65,
    y: 816.93,
    width: 25.24,
    height: 32.26
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 848.72,
    y: 649.31,
    width: 93.96,
    height: 27.35
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 849.07,
    y: 709.07,
    width: 93.96,
    height: 27.35
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 849.42,
    y: 768.83,
    width: 93.96,
    height: 27.35
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 849.77,
    y: 828.31,
    width: 93.96,
    height: 27.35
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 393.85,
    y: 591.69,
    width: 12.62,
    height: 26.65
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1015.25,
    y: 716.27,
    width: 31.55,
    height: 40.67
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1015.25,
    y: 776.05,
    width: 31.55,
    height: 40.67
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1015.25,
    y: 835.68,
    width: 31.55,
    height: 40.67
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M377.77,850.23s-34.11,20.58,28.76,52.26c0,0,13.87-25.71-1.46-46.68a20.65,20.65,0,0,0-26.79-5.87Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M378.64,849.8s29.19,22.33,28.38,52.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M408.73,903.66s-10.68-36.29,2-63a57.33,57.33,0,0,0,4.64-36,97,97,0,0,0-5.09-16.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M418.16,768.11c0,4.44-8.06,17.33-8.06,17.33s-8.05-12.9-8.05-17.33a8.05,8.05,0,1,1,16.1-.51v.51Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M431.56,793.15c-2.41,3.74-16.18,10.18-16.18,10.18s.25-15.2,2.67-18.93a8.05,8.05,0,0,1,13.51,8.75Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M431,836c-4,2-19.11.62-19.11.62s7.89-13,11.86-15A8.05,8.05,0,1,1,431,836Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M423.31,868.47c-3.57,2.65-18.73,3.84-18.73,3.84s5.58-14.14,9.15-16.79a8.06,8.06,0,0,1,9.65,12.9l-.07.05Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M398.36,804.37c3.19,3.1,18.05,6.31,18.05,6.31s-3.64-14.76-6.83-17.87a8.05,8.05,0,1,0-11.37,11.41l.15.15Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M389.87,842.32c4,2,19.11.62,19.11.62s-7.89-13-11.86-15a8.05,8.05,0,0,0-7.26,14.38Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M386.63,881.2c3.57,2.65,18.73,3.84,18.73,3.84s-5.58-14.14-9.16-16.79a8.06,8.06,0,0,0-9.65,12.9l.07.05Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M418.16,768.11c0,4.44-8.06,17.33-8.06,17.33s-8.05-12.9-8.05-17.33a8.05,8.05,0,1,1,16.1-.51v.51Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M431.56,793.15c-2.41,3.74-16.18,10.18-16.18,10.18s.25-15.2,2.67-18.93a8.05,8.05,0,0,1,13.51,8.75Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M431,836c-4,2-19.11.62-19.11.62s7.89-13,11.86-15A8.05,8.05,0,1,1,431,836Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M423.31,868.47c-3.57,2.65-18.73,3.84-18.73,3.84s5.58-14.14,9.15-16.79a8.06,8.06,0,0,1,9.65,12.9l-.07.05Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M398.36,804.37c3.19,3.1,18.05,6.31,18.05,6.31s-3.64-14.76-6.83-17.87a8.05,8.05,0,1,0-11.37,11.41l.15.15Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M389.87,842.32c4,2,19.11.62,19.11.62s-7.89-13-11.86-15a8.05,8.05,0,0,0-7.26,14.38Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M386.63,881.2c3.57,2.65,18.73,3.84,18.73,3.84s-5.58-14.14-9.16-16.79a8.06,8.06,0,0,0-9.65,12.9l.07.05Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1063.16,899.28s-14.27-48.46,2.68-84.12a76.48,76.48,0,0,0,6.19-48,128,128,0,0,0-6.8-22.56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1075.78,718c0,5.94-10.75,23.14-10.75,23.14s-10.76-17.22-10.76-23.14a10.75,10.75,0,0,1,21.5-.59,5.81,5.81,0,0,1,0,.59Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1093.55,751.44c-3.22,5-21.61,13.6-21.61,13.6s.34-20.3,3.56-25.29A10.75,10.75,0,1,1,1093.83,751l-.28.44Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1092.78,808.67c-5.31,2.67-25.52.83-25.52.83s10.53-17.36,15.84-20a10.75,10.75,0,1,1,9.92,19.08l-.24.12Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1082.61,852c-4.77,3.52-25,5.12-25,5.12s7.45-18.88,12.22-22.42a10.76,10.76,0,0,1,12.79,17.3Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1049.36,766.41c4.26,4.14,24.11,8.42,24.11,8.42s-4.86-19.7-9.12-23.85a10.76,10.76,0,0,0-15,15.43Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1038.13,817.11c5.3,2.67,25.52.83,25.52.83s-10.54-17.36-15.84-20a10.75,10.75,0,0,0-9.68,19.2Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1033.79,868.07c4.78,3.53,25,5.13,25,5.13s-7.45-18.89-12.23-22.42a10.75,10.75,0,0,0-12.79,17.29Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M365.31,899.66s9.3-31.55-1.75-54.79a49.82,49.82,0,0,1-4-31.27A83.56,83.56,0,0,1,364,798.92"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M357.09,781.2c0,3.87,7,15.08,7,15.08s7-11.22,7-15.08a7,7,0,1,0-14,0v0Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M345.51,803c2.1,3.25,14.08,8.86,14.08,8.86s-.21-13.23-2.32-16.48a7,7,0,0,0-12.11,7.08c.11.19.23.37.35.54Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M346,840.19c3.45,1.74,16.62.54,16.62.54s-6.86-11.3-10.31-13A7,7,0,0,0,346,840.2Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M352.64,869.89c3.12,2.3,16.3,3.34,16.3,3.34s-4.85-12.3-8-14.6a7,7,0,0,0-8.33,11.26Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M374.29,812.71c-2.8,2.69-15.7,5.49-15.7,5.49s3.17-12.84,5.94-15.53a7,7,0,1,1,10.24,9.59,5.11,5.11,0,0,1-.48.45Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M381.63,845.7c-3.46,1.74-16.62.54-16.62.54s6.86-11.3,10.31-13a7,7,0,0,1,6.31,12.51Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M384.44,880.14c-3.12,2.3-16.3,3.33-16.3,3.33s4.88-12.3,8-14.6a7,7,0,0,1,8.33,11.27Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M559.82,556.11H555a3.38,3.38,0,1,0,.31-6.75H515.91a3.38,3.38,0,0,0,0,6.75h4.83a3.38,3.38,0,0,0-.31,6.76H514a3.38,3.38,0,1,0-.3,6.75h39.38a3.38,3.38,0,1,0,.31-6.75h6.45a3.38,3.38,0,0,0,.3-6.76Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M733.37,642.56h-4.83a3.38,3.38,0,1,0,.31-6.75H689.46a3.38,3.38,0,0,0,0,6.75h4.83a3.38,3.38,0,0,0-.31,6.75,1.6,1.6,0,0,0,.31,0h-6.75a3.38,3.38,0,0,0-.31,6.76h39.38a3.38,3.38,0,0,0,.31-6.76h6.45a3.38,3.38,0,1,0,.3-6.75Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1029.05,530.17h-4.82a3.38,3.38,0,1,0,.31-6.75H985.15a3.38,3.38,0,0,0,0,6.75H990a3.38,3.38,0,1,0-.3,6.75h-6.45a3.38,3.38,0,0,0-.31,6.75h39.39a3.38,3.38,0,0,0,0-6.75h6.75a3.38,3.38,0,1,0,.31-6.75Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M653.71,775.88l-.83.61A3.48,3.48,0,0,0,653.71,775.88Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M654.37,776.55l-.84.61A3.61,3.61,0,0,0,654.37,776.55Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M654.37,775.88l-.84.61A3.34,3.34,0,0,0,654.37,775.88Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1017,899.66s9.65-32.76-1.81-56.87a51.71,51.71,0,0,1-4.18-32.46,86.26,86.26,0,0,1,4.6-15.26"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1008.5,777.1c0,4,7.27,15.65,7.27,15.65S1023,781.1,1023,777.1a7.27,7.27,0,1,0-14.54-.34v.34Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M996.49,799.71c2.18,3.37,14.61,9.19,14.61,9.19s-.23-13.72-2.41-17.1a7.27,7.27,0,1,0-12.45,7.51c.08.13.16.26.25.39Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M997,838.4c3.59,1.81,17.26.56,17.26.56s-7.13-11.73-10.71-13.54a7.27,7.27,0,1,0-6.55,13Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1003.88,867.72c3.23,2.38,16.92,3.46,16.92,3.46s-5-12.77-8.27-15.16a7.27,7.27,0,0,0-8.69,11.66Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1026.37,809.83c-2.88,2.8-16.3,5.7-16.3,5.7s3.28-13.33,6.16-16.13a7.27,7.27,0,0,1,10.25,10.32l-.12.11Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1034,844.11c-3.59,1.8-17.25.56-17.25.56s7.12-11.74,10.71-13.55a7.27,7.27,0,0,1,6.54,13Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1036.89,878.56C1033.66,881,1020,882,1020,882s5-12.77,8.26-15.16a7.27,7.27,0,1,1,8.69,11.66l0,0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongBuildingMobile);
export default __webpack_public_path__ + "static/media/long_building_mobile.44c65b07b9f435b01b72dcd727635a5e.svg";
export { ForwardRef as ReactComponent };